
import React from 'react';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';

const HomePage: React.FC = () => {
  return (
    <div>
      <HeroSection />
      <ServicesSection />
      <PricingSection />
      <ProcessSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
